import http from '../lib/http';

export const getWishlists = async () => {
  const response = await http.get('/api/customer/wishlists');
  return response.data;
};

export const addToWishlist = async (productId) => {
  const formData = new FormData();
  formData.append('product_id', productId);

  const response = await http.post('/api/customer/wishlists', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const removeFromWishlist = async (wishlistId) => {
  const response = await http.delete(`/api/customer/wishlists/${wishlistId}`);
  return response.data;
};

// Check if a product is in wishlist
export const checkWishlistStatus = async (productId) => {
  try {
    const { data } = await getWishlists();
    const wishlistItems = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
    return wishlistItems.find(item => 
      item.product_id === productId || 
      item.product?.id === productId
    );
  } catch (error) {
    console.error('Error checking wishlist status:', error);
    return null;
  }
};
